'use client'

import { useTranslations } from 'next-intl'
import type { ReactNode } from 'react'

import { SectionErrorBoundary } from '@/shared/components/ErrorBoundary'

type TasksSectionErrorBoundaryProps = {
  children: ReactNode
}

export function TasksSectionErrorBoundary({
  children
}: TasksSectionErrorBoundaryProps) {
  const t = useTranslations('tasksPage.errors.section')

  return (
    <SectionErrorBoundary
      title={t('title')}
      description={t('description')}
      retryLabel={t('retry')}
    >
      {children}
    </SectionErrorBoundary>
  )
}
